import { render, staticRenderFns } from "./DictionaryManaged.vue?vue&type=template&id=29097d30&scoped=true&"
import script from "./DictionaryManaged.vue?vue&type=script&lang=js&"
export * from "./DictionaryManaged.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryManaged.vue?vue&type=style&index=0&id=29097d30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29097d30",
  null
  
)

export default component.exports